export default {
  welcome: 'Boas-vindas',
  we_miss_you: 'Temos saudades de si',
  happy_friday: 'Feliz Sexta-feira',
  lazy_sunday: 'Domingo Preguiçoso',
  loyalty_program: 'Programa de Fidelidade',
  you_might_also_like: 'Também pode gostar',
  storefront_promo: 'Promoção da Loja',
  welcome_members_club: 'Boas-vindas ao clube de membros',
  launch_deal: 'Oferta de lançamento',
};
